var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, Lifecycle, scoped } from 'tsyringe';
import { Identity, IdentityInjectionToken } from '../identity/Identity';
import { StreamMessage } from '../protocol/StreamMessage';
import { createSignaturePayload } from './createSignaturePayload';
let MessageSigner = class MessageSigner {
    identity;
    constructor(identity) {
        this.identity = identity;
    }
    async createSignedMessage(opts, signatureType) {
        const signature = await this.identity.createMessageSignature(createSignaturePayload(opts));
        return new StreamMessage({
            ...opts,
            signature,
            signatureType
        });
    }
};
MessageSigner = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(IdentityInjectionToken)),
    __metadata("design:paramtypes", [Identity])
], MessageSigner);
export { MessageSigner };
//# sourceMappingURL=MessageSigner.js.map